import ReactDOM from "react-dom/client"
import App from "./App"
import "./style/output.css"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)
